import type {Node} from "prosemirror-model";
import type {EditorView} from "prosemirror-view";
import type {EditorState, Transaction} from "prosemirror-state";
import {TextSelection} from "prosemirror-state";


import {replaceSelectionParagraphWithNode, replaceTextRangeWithNode} from "./utils";
import {TriggerActionCommandAdditionalParams} from "./types";


import {schema} from "../../config/schema";


const DEFAULT_WIDTH = 2;
const DEFAULT_HEIGHT = 2;

export const insertTable = (state: EditorState, dispatch?: (tr: Transaction) => void, view?: EditorView, additionalParams?: TriggerActionCommandAdditionalParams) => {
    const cellNodeType = schema.nodes.tableDataCell;
    const rowNodeType = schema.nodes.tableRow;

    const tableNode = schema.nodes.table.create()!;

    let tr;
    if ((additionalParams?.nodePos !== undefined) && (additionalParams?.textInput !== undefined)) {
        tr = replaceTextRangeWithNode(state, additionalParams.nodePos, additionalParams.nodePos + additionalParams.textInput.length + 1, tableNode);
    } else {
        tr = replaceSelectionParagraphWithNode(state, tableNode);
    }

    const rows = [];
    for (let h = 0; h < DEFAULT_HEIGHT; h++) {
        const cells: Node[] = [];
        for (let t = 0; t < DEFAULT_WIDTH; t++) {
            cells.push(cellNodeType.createAndFill()!);
        }
        rows.push(rowNodeType.create(null, cells));
    }
    const { $from } = state.selection;
    tr.insert($from.before(), rows);
    tr.setSelection(TextSelection.near(tr.doc.resolve($from.before())));

    if (tr !== state.tr) {
        if (dispatch && view) {
            dispatch(tr);
            view.focus();
        }
        return true;
    }
    return false;
}
